var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react';
import Modal from '../../ui/uiElements/advanced/modal/ModalComponent';
import StackLayout from '../../ui/uiElements/layouts/stackLayout/StackLayoutComponent';
import TextInput from '../../ui/uiElements/core/textInput/TextInputComponent';
import Button from '../../ui/uiElements/core/button/ButtonComponent';
import ApplicationInsights from '../../insights/providers/ApplicationInsights';
import Text from '../../ui/uiElements/core/text/TextComponent';
import useModalStore from '../../ui/uiElements/advanced/modal/dataLayer/hooks/UseModalStore';
// import ConsoleHistory from '../../insights/ConsoleHistory';
export var bugReporterModalKey = 'bugReporter';
var BugReporter = function () {
    var _a = __read(useState(''), 2), message = _a[0], setMessage = _a[1];
    var _b = __read(useState(false), 2), sending = _b[0], setSending = _b[1];
    var modalStore = useModalStore();
    var handleSendReportPress = useCallback(function () {
        var _a;
        ApplicationInsights.applicationInsights.trackEvent({
            name: 'customBugReport',
            properties: __assign({ message: message }, modalStore.getActiveParameters(bugReporterModalKey))
        });
        setSending(true);
        ApplicationInsights.applicationInsights.flush();
        setSending(false);
        // JUST BACKUP
        ApplicationInsights.applicationInsights.trackEvent({
            name: 'customBugReportSLIM',
            properties: {
                message: message,
                //...ConsoleHistory.getHistoryStringObject(),
                patch: (_a = modalStore.getActiveParameters(bugReporterModalKey)) === null || _a === void 0 ? void 0 : _a.patch
            }
        });
        setSending(true);
        ApplicationInsights.applicationInsights.flush();
        setSending(false);
        alert('Meldung gesendet');
        modalStore.closeModal();
    }, [message]);
    return (React.createElement(Modal, { title: "Problem melden", modalKey: bugReporterModalKey }, sending ? (React.createElement(StackLayout, null,
        React.createElement(Text, null, "..."))) : (React.createElement(StackLayout, { width100: true },
        React.createElement(TextInput, { placeholder: "What went wrong?", multiline: true, value: message, onChange: setMessage }),
        React.createElement(Button, { marginTop: true, onPress: handleSendReportPress }, "Send")))));
};
export default observer(BugReporter);
//# sourceMappingURL=BugReporter.js.map